import { createTheme } from '@mui/material/styles';
import { MAIN_THEME } from '@styles';

export function createMuiThemeFromCustomTheme() {
  return createTheme({
    palette: {
      primary: {
        light: MAIN_THEME.color.white86,
        main: MAIN_THEME.color.white86,
        dark: MAIN_THEME.color.black25,
      },
      secondary: {
        light: MAIN_THEME.color.white86,
        main: MAIN_THEME.color.white86,
        dark: MAIN_THEME.color.black25,
      },
      error: {
        main: MAIN_THEME.color.red,
      },
    },
  });
}
